import React, { useState, useEffect } from 'react';
import ArchivedQuestions from 'containers/Reports/archived-questions';
import PrescreenQuestions from 'containers/Reports/prescreen-questions';
import AssessmentByQuestionType from 'containers/Reports/assessment-by-questionnaire-type';
import CertificateOnFile from 'containers/Reports/certificate-on-file';
import ConditionalApprovalComments from 'containers/Reports/conditional-approval-comments';
import IndividualRequest from 'containers/Reports/individual-request';
import OutstandingAssessments from 'containers/Reports/outstanding-assessments';
import PendingRenewals from 'containers/Reports/pending-renewals';
import {
  Container,
  HeaderFlexRow,
  HeadingTitle,
  Table,
  ResultsHeaderRow,
  TableData,
  ResultsHeader,
} from 'components/styled-components';
import { NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

const queryByTitle = (query, title) =>
  title.includes(query.toUpperCase().trim());

const ReportRowsWithMetadata = [
  {
    title: 'ARCHIVED QUESTIONS',
    component: <ArchivedQuestions key="report1" />,
  },
  {
    title: 'ASSESSMENT BY QUESTION TYPE',
    component: <AssessmentByQuestionType key="report3" />,
  },
  {
    title: 'CERTIFICATE ON FILE',
    component: <CertificateOnFile key="report4" />,
  },
  {
    title: 'CONDITIONAL APPROVAL COMMENTS',
    component: <ConditionalApprovalComments key="report5" />,
  },
  {
    title: 'INDIVIDUAL REQUEST',
    component: <IndividualRequest key="report6" />,
  },
  {
    title: 'OUTSTANDING ASSESSMENTS',
    component: <OutstandingAssessments key="report7" />,
  },
  {
    title: 'PENDING RENEWALS',
    component: <PendingRenewals key="report8" />,
  },
  {
    title: 'PRESCREEN QUESTIONS',
    component: <PrescreenQuestions key="report2" />,
  },
];

const Reports = () => {
  const [query] = useState('');
  const [reportRows, setReportRows] = useState(
    ReportRowsWithMetadata.map(row => row.component)
  );
  useEffect(() => {
    setReportRows(
      ReportRowsWithMetadata.filter(row => queryByTitle(query, row.title)).map(
        row => row.component
      )
    );
  }, [query]);
  return (
    <Container>
      <HeaderFlexRow>
        <HeadingTitle>Reports</HeadingTitle>
      </HeaderFlexRow>
      {/* <SearchWrapper padding="1rem 2rem">
        <ControlWrapper>
          <InputGroup
            value={query}
            leftIcon={IconNames.SEARCH}
            placeholder="Search Reports"
            className="medium-text-group light-blue"
            onChange={({ target }) => setQuery(target.value)}
          />
        </ControlWrapper>
      </SearchWrapper> */}
      <Table>
        <tbody>
          <ResultsHeaderRow>
            <ResultsHeader>Report Name</ResultsHeader>
            <ResultsHeader>Description</ResultsHeader>
            <ResultsHeader />
          </ResultsHeaderRow>

          {reportRows.length ? (
            reportRows
          ) : (
            <tr>
              <TableData colSpan={3}>
                <NonIdealState
                  icon={IconNames.SEARCH}
                  title="No reports found"
                  description="Your search did not match any reports"
                />
              </TableData>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default Reports;
